/* eslint-disable */
require('./add')
require('./addFile')
require('./admin-panel')
require('./arrow')
require('./attach')
require('./big_arrow')
require('./calendar')
require('./cancel')
require('./checkmark')
require('./clear')
require('./clock')
require('./close_eye')
require('./copy')
require('./delete')
require('./doc')
require('./download')
require('./edit')
require('./eye')
require('./guide')
require('./info')
require('./lock')
require('./mark')
require('./middle_arrow')
require('./minus')
require('./open-view')
require('./options-dot')
require('./options')
require('./osr-accept')
require('./osr-reject')
require('./osr')
require('./plus')
require('./printer')
require('./quit')
require('./search')
require('./settings')
require('./sortDown')
require('./success')
require('./tickets-clear')
require('./user_restore')
require('./user')
require('./users')
require('./warn')
